import { ref, computed, onMounted, onUnmounted } from 'vue';

/* Телефон — только просмотр.

   Решение заказчика: мобильного приложения в MVP нет, а MES, открытый
   в браузере телефона, работает в режиме чтения.

   ПОЧЕМУ ЭТО ПРАВИЛЬНО, А НЕ ЛЕНЬ

   Экраны системы рассчитаны на палец в перчатке и на цель не меньше 44 px.
   На 375 пикселях ширины такие цели не помещаются рядом — их пришлось бы
   уменьшить, а уменьшенная кнопка «Брак» на телефоне мастера, идущего
   по цеху, однажды нажмётся вместо «Годное». Ошибка учёта, сделанная
   на бегу, дороже, чем отсутствие возможности сдать выпуск с телефона.

   К тому же сдача выпуска и так привязана к терминалу станка: в учёте
   должно остаться, кто и где это сделал. Телефон в кармане — не то место.

   ЧТО ИМЕННО ОТКЛЮЧАЕТСЯ

   Только действия, меняющие данные. Смотреть можно всё, что роль и так
   видит: ход заказов, состояние станков, сменный отчёт, аналитику.
   Именно за этим руководство и открывает систему с телефона.

   ГРАНИЦА

   768 пикселей — планшет. Планшет у станка остаётся полноценным рабочим
   местом, и порог выбран так, чтобы он туда не попал ни в одной
   ориентации: 768×1024 в портрете — это ровно 768, и он должен работать. */

const ПОРОГ = 767;

const узкий = ref(false);
const подписчиков = ref(0);
let медиа = null;

function пересчитать(e) {
  узкий.value = e ? e.matches : window.matchMedia?.(`(max-width: ${ПОРОГ}px)`).matches ?? false;
}

export function useSmallScreen() {
  onMounted(() => {
    подписчиков.value += 1;
    if (!медиа && window.matchMedia) {
      медиа = window.matchMedia(`(max-width: ${ПОРОГ}px)`);
      пересчитать(медиа);
      медиа.addEventListener('change', пересчитать);
    }
  });
  onUnmounted(() => { подписчиков.value -= 1; });

  return {
    /* Узкий экран сам по себе. Отдельно от режима чтения: экран может
       быть узким, а действия — разрешёнными, если завод так решит. */
    узкий: computed(() => узкий.value),
    /* Режим просмотра. Пока это одно и то же, но названия разные
       намеренно: когда появится настройка «разрешить действия с телефона»,
       менять придётся одно место, а не все экраны. */
    толькоЧтение: computed(() => узкий.value),
  };
}

/* Для мест вне компонентов (роутер, сторы). */
export const экранУзкий = () => window.matchMedia?.(`(max-width: ${ПОРОГ}px)`).matches ?? false;
